import { render, staticRenderFns } from "./AddSpending.vue?vue&type=template&id=1ec4f398&scoped=true&"
import script from "./AddSpending.vue?vue&type=script&lang=js&"
export * from "./AddSpending.vue?vue&type=script&lang=js&"
import style0 from "./AddSpending.vue?vue&type=style&index=0&id=1ec4f398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec4f398",
  null
  
)

export default component.exports